import React from "react";

/**
 * Reusable spinner loader.
 *
 * Props:
 *   size    — "sm" | "md" (default) | "lg"
 *   className — additional classes
 */
const SIZE = {
  sm: "h-4 w-4 border-2",
  md: "h-6 w-6 border-2",
  lg: "h-10 w-10 border-[3px]",
};

export function Spinner({ size = "md", className = "" }) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={`inline-block rounded-full border-slate-200 border-t-teal-600 animate-spin ${SIZE[size]} ${className}`}
    />
  );
}
